export const SaneString = (val?: any): string => {
  if (typeof val === 'undefined' || !val) {
    return '';
  }

  return String(val).valueOf();
};

export const SaneNumber = (val?: any): number => {
  if (typeof val === 'undefined' || !val) {
    return 0;
  }

  return Number(val).valueOf();
};

export const SaneArray = <T>(val?: any): T[] => {
  if (!Array.isArray(val)) {
    return [];
  }

  return val;
};
